export default __webpack_public_path__ + "media/zurb/img/legacy/icons/notable/pro-enroll-48accab54ce5e61a5af908250289f0d7.png";